import { PayloadAction } from '../../../store.model';
import { ActionType } from '../main.action';
import { MainState } from '../main.state';

import { SelectUser } from './select-user.action';

export function selectUserReducer(
    state: MainState,
    action: PayloadAction<ActionType.EVAL_MAIN__SELECT_USER, SelectUser>,
): MainState {
    return {
        ...state,
        selectedUser: {
            value: action.payload.user,
            initialLoad: false,
        },
        selectedTemplateVersionId: null,
    };
}
